/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Meta_TitleInputs */

const en_svc_research_meta_title = /** @type {(inputs: Svc_Research_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Research Agents — Sourced Market & Lead Research | Lindevo`)
};

const lv_svc_research_meta_title = /** @type {(inputs: Svc_Research_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI izpētes aģenti — tirgus un klientu izpēte ar avotiem | Lindevo`)
};

/**
* | output |
* | --- |
* | "AI Research Agents — Sourced Market & Lead Research \| Lindevo" |
*
* @param {Svc_Research_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_meta_title = /** @type {((inputs?: Svc_Research_Meta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Meta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_meta_title(inputs)
	return en_svc_research_meta_title(inputs)
});